import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=60f77ea6"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports